import type { TypeAppSkeleton } from '../types/generated/contentful'
import type { AppContent } from './contentful-types'
import { contentfulClient } from './contentful-client'
import { mapAppContent } from './contentful-mappers'
import { getSingletonEntry } from './contentful-singleton'

export async function fetchAppContent(locale: string): Promise<AppContent> {
  const response = await contentfulClient.getEntries<TypeAppSkeleton>({
    content_type: 'app',
    include: 10,
    locale,
    select: [
      'fields.name',
      'fields.settingsPage',
      'fields.onboardingIntroStep',
      'fields.onboardingCreateProfile',
      'fields.onboardingPaymentStep',
      'fields.warmupSubject',
      'fields.sessionDefinition',
    ],
  })

  const app = getSingletonEntry(response.items, 'app')

  return mapAppContent(app)
}

export type { AppContent, ContentView } from './contentful-types'
